import { render } from "./TransferFirstUseBlankslate.vue?vue&type=template&id=91de86e8"
import script from "./TransferFirstUseBlankslate.vue?vue&type=script&lang=js"
export * from "./TransferFirstUseBlankslate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__